/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { atom } from 'jotai';
import { activeSanctioningBodyIdAtom } from 'jotai/sanctioningBody';
import { activeSessionSelector } from 'jotai/session';
import { RunType, SanctioningBodyEnum } from 'models/viewModels';
import { DashboardType } from './DashboardObject';

const isIndyDashboardSelector = atom<boolean>((get) => {
  return (
    Number(get(activeSanctioningBodyIdAtom) || '') === SanctioningBodyEnum.INDYCAR ||
    Number(get(activeSessionSelector)?.seriesId || '') === 4 // Session.seriesId is not an enum :(
  );
});

const isQualifyingDashboardSelector = atom<boolean>((get) => {
  const activeSession = get(activeSessionSelector);
  return activeSession?.sessionType === RunType.QUALIFYING && !get(isIndyDashboardSelector);
});

export const activeDashboardTypeSelector = atom<DashboardType>((get) => {
  return get(isQualifyingDashboardSelector)
    ? DashboardType.Qualifying
    : get(isIndyDashboardSelector)
    ? DashboardType.IndyCar
    : DashboardType.Default;
});
